import { render } from "./SEOHead.vue?vue&type=template&id=84536cd6"
import script from "./SEOHead.vue?vue&type=script&lang=js"
export * from "./SEOHead.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__